var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarAcademyBishop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 322.57 454.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #261b1f;\n        opacity: .6;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #eaceb9;\n      }\n\n      .cls-3 {\n        fill: #50eadb;\n      }\n\n      .cls-4 {\n        fill: #d8b89a;\n      }\n\n      .cls-5 {\n        fill: #2b2b89;\n      }\n\n      .cls-6 {\n        fill: #3939b2;\n      }\n\n      .cls-7 {\n        fill: #6d6e70;\n      }\n\n      .cls-8 {\n        fill: #5e3418;\n      }\n\n      .cls-9 {\n        fill: #7c4b27;\n      }\n\n      .cls-10 {\n        fill: #9f6b46;\n      }\n\n      .cls-11 {\n        fill: #724526;\n      }\n\n      .cls-12 {\n        fill: #7997bc;\n      }\n\n      .cls-13 {\n        fill: #86562e;\n      }\n\n      .cls-14 {\n        fill: #e3c5a9;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "296.27 437.77 24.82 437.77 81.81 383.85 107.85 336.77 213.44 336.77 239.67 384.72 296.27 437.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "189.82 437.77 131.82 437.77 105.82 370.13 103.82 302.77 216.82 302.77 215.82 370.13 189.82 437.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "189.52 437.77 131.12 437.77 105.82 320.77 215.82 320.77 189.52 437.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "183.23 398.14 160.25 427.61 137.26 398.14 128.54 350.77 160.25 360.77 191.96 350.77 183.23 398.14"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "198.41 236.77 291.08 138.64 284.25 127.79 175.99 218.04 198.41 236.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "195.67 227.78 220.89 159.47 214.86 155.18 182.41 217.77 195.67 227.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "220.65 159.16 197.14 106.85 199.64 125.79 212.87 160.99 220.65 159.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "291.41 138.63 291.36 31.29 298.3 17.43 283.93 29.21 273.18 139.13 291.41 138.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "291.23 54.7 266.68 14.07 255.55 0 252.12 1.01 265.03 20.35 284.03 58.18 291.23 54.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "290.91 122.62 320.46 71.53 320.59 62.35 281.21 114.08 290.91 122.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "236.63 182.28 251.43 142.21 247.89 139.69 228.85 176.41 236.63 182.28"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "225.05 256.04 191.87 231.96 223.59 204.5 286.76 188.59 260.48 244.8 225.05 256.04"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "123.82 236.77 31.15 138.64 37.98 127.79 146.24 218.04 123.82 236.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "126.56 227.78 101.34 159.47 107.37 155.18 139.82 217.77 126.56 227.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "101.57 159.16 125.08 106.85 122.58 125.79 109.36 160.99 101.57 159.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "30.82 138.63 30.87 31.29 23.92 17.43 38.3 29.21 49.05 139.13 30.82 138.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "31 54.7 55.54 14.07 66.68 0 70.11 1.01 57.19 20.35 38.2 58.18 31 54.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "31.31 122.62 1.77 71.53 1.64 62.35 41.02 114.08 31.31 122.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "85.6 182.28 70.8 142.21 74.34 139.69 93.37 176.41 85.6 182.28"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "97.7 256.05 130.87 231.96 99.16 204.51 35.98 188.6 62.27 244.8 97.7 256.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "181.82 374.77 160.82 382.77 139.82 374.77 104.91 326.77 96.82 255.77 146.04 218.2 160.82 219.77 175.91 218.33 224.82 255.77 216.73 326.77 181.82 374.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "175.69 366.18 160.87 370.77 146.04 366.18 142 356.99 160.87 355.54 179.73 356.99 175.69 366.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "182.87 360.77 160.87 360.77 138.87 360.77 132.87 336.77 151.85 308.7 160.87 309.77 169.49 308.62 188.87 336.77 182.87 360.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "171.79 351.2 160.87 352.77 149.95 351.2 146.37 337.18 160.87 334.77 175.36 337.18 171.79 351.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "235.75 251.32 207.78 229.01 234.68 209.59 282.93 195.94 259.69 244.09 235.75 251.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "147.38 362.81 160.77 365.08 174.17 362.81 177.82 361.05 160.77 360.77 143.72 361.05 147.38 362.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "138.66 296.95 120.82 300.37 113.8 292.79 112.88 285.71 124.01 283.74 129.96 286.76 138.66 296.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "179.61 259.15 160.99 264.77 142.37 259.15 128.82 230.77 146.34 217.27 160.99 219.89 175.65 217.27 192.82 230.77 179.61 259.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "86.74 251.1 114.71 228.79 87.81 209.37 39.56 195.72 62.81 243.87 86.74 251.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "232.4 372.47 283.4 402.47 282.4 378.47 222.4 353.47 232.4 372.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "183.35 297.08 201.18 300.5 208.21 292.92 209.13 285.84 198 283.87 192.05 286.89 183.35 297.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "88.82 373.77 37.82 403.77 38.82 379.77 98.82 354.77 88.82 373.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "322.57 454.77 0 454.77 14.89 396.77 39.79 378.77 161.29 418.63 282.79 378.77 307.68 396.77 322.57 454.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "261.57 454.77 59 454.77 73.89 386.77 138.79 396.77 160.29 404.63 181.79 396.77 246.68 386.77 261.57 454.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "88.82 454.77 50.82 454.77 43.34 400.07 47.82 382.32 92.82 365.37 106.16 391.17 98.04 440.07 88.82 454.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "232.82 454.77 267.82 454.77 276.52 400.07 272.82 382.32 228.82 365.37 215.53 391.39 223.57 440.05 232.82 454.77"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarAcademyBishop);
export default __webpack_public_path__ + "static/media/avatar-academy-bishop.7ee0556d2d1343c3ed3f488d23e12441.svg";
export { ForwardRef as ReactComponent };